import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { FranchiseStatus } from "src/app/franchise-app-global";
import { CrTypeEnum } from "../../../models/crType-enum";
import {
  Franchises,
  FranchisesSearchModel,
} from "../../../models/franchise-admin-list";
import { FranchisesAdminService } from "../../../services/franchises-admin.service";
import { FileDownloadService } from "src/app/shared/providers/file-download/file-download.service";
import { FileDto } from "src/app/shared/models/models";
import { BaseComponent } from "src/app/shared/base/base-component";

@Component({
  selector: "app-franchise-admin-list",
  templateUrl: "./franchise-admin-list.component.html",
  styleUrls: ["./franchise-admin-list.component.scss"],
})
export class FranchisesAdminListComponent extends BaseComponent implements OnInit {
  private _error = new Subject<string>();
  errorMessage: string | null;
  fired: boolean = false;
  active: number;
  isInternal: boolean = true;
  searchText: string = "";
  franchiseStatus = FranchiseStatus;
  public franchises: Franchises = {};
  public franchisesSearchModel: FranchisesSearchModel = {
    pageSize: 10,
    pageNumber: 1,
  };
  public selectedCountries: Array<any> = [];

  constructor(
    private franchisesAdminService: FranchisesAdminService,
    private route: ActivatedRoute,
    private fileDownloadService: FileDownloadService
  ) {
    super();
  }

  ngOnInit(): void {
    this.isInternal = this.route.snapshot.data["isInternal"];
    this.GetActiveTab();   
    this.franchisesSearchModel.crType =
      this.isInternal === true ? CrTypeEnum.Internal : CrTypeEnum.External;

    this.GetAdminFranchises();
  }
  GetAdminFranchises() {
    this.franchisesAdminService
      .getAllAdminFranchises(this.franchisesSearchModel)
      .subscribe(
        (data: any) => {
          this.franchises.franchiseModel = [];
          this.franchises.franchiseModel = data.items;
          this.franchises.pageNumber = data.pageNumber;
          this.franchises.pageSize = data.pageSize;
          this.franchises.totalCount = data.totalCount;
          this.fired = true;
        },
        (error) => {
          if (error.status == "403")
            this._error.next(error.error.error.message);
          else
            this.translate
              .get("ErrorCodes.RetrieveError")
              .subscribe((msg) => this._error.next(msg));
          window.scrollTo(0, 0);
        }
      );
  }
  exportAdminFranchisesAsExcel() {
    this.franchisesAdminService
      .exportAllAdminFranchisesAsExcel(this.franchisesSearchModel)
      .subscribe(
        (data: FileDto) => {
          if (data) this.fileDownloadService.downloadFromBytes(data);
        },
        (error) => {
          if (error.status == "403")
            this._error.next(error.error.error.message);
          else
            this.translate
              .get("ErrorCodes.RetrieveError")
              .subscribe((msg) => this._error.next(msg));
          window.scrollTo(0, 0);
        }
      );
  }
  exportAdminFranchisesAsPdf() {
    this.franchisesAdminService
      .exportAllAdminFranchisesAsPdf(this.franchisesSearchModel)
      .subscribe(
        (data: FileDto) => {
          if (data) this.fileDownloadService.downloadFromBytes(data);
        },
        (error) => {
          if (error.status == "403")
            this._error.next(error.error.error.message);
          else
            this.translate
              .get("ErrorCodes.RetrieveError")
              .subscribe((msg) => this._error.next(msg));
          window.scrollTo(0, 0);
        }
      );
  }
  refreshGrid(search: FranchisesSearchModel) {
    this.franchisesSearchModel = search;
    this.changeStatus();
  }
  changeStatus(reset: boolean = false) {
    if (reset) this.resetFranchisesSearchModel();
    this.GetActiveTab();
    this.GetAdminFranchises();
  }
  GetActiveTab() {
      let value = this.isInternal === true? sessionStorage.getItem("activeTab"):sessionStorage.getItem("externalactiveTab");
      this.active = value !== null ? parseInt(value) : 1;
      this.franchisesSearchModel.Status =
        this.active === 2
          ? this.franchiseStatus.Approved
          : this.active === 3
          ? this.franchiseStatus.Suspended
          : this.active === 4
          ? this.franchiseStatus.Violated
          : this.active === 5
          ? this.franchiseStatus.Canceled
          : this.active === 6
          ? this.franchiseStatus.Expired
          : this.franchiseStatus.All;
  }
  SetActiveTab(val: number) {
    if (this.isInternal) {
      sessionStorage.setItem("activeTab", val.toString());
    } else {
      sessionStorage.setItem("externalactiveTab", val.toString());
    }
  }
  resetFranchisesSearchModel() {
    this.franchisesSearchModel = {
      pageSize: 10,
      pageNumber: 1,
    };
    this.franchisesSearchModel.crType =
      this.isInternal === true ? CrTypeEnum.Internal : CrTypeEnum.External;
  }
}
